/* ============================================================
   Ultra Club — global.js
   ============================================================ */
(function () {
  'use strict';

  const UC = window.UltraClub || {};
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  const overlay = $('[data-overlay]');

  /* ---------- Header height → CSS var (sticky offsets + anchor scroll) ---------- */
  const headerEl = $('[data-header]');
  function setHeaderHeight() {
    if (!headerEl) return;
    const h = Math.round(headerEl.getBoundingClientRect().height);
    if (h > 0) document.documentElement.style.setProperty('--header-height', h + 'px');
  }
  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight);
  window.addEventListener('load', setHeaderHeight);

  /* ---------- Overlay helpers ---------- */
  function showOverlay(onClose) {
    if (!overlay) return;
    overlay.hidden = false;
    requestAnimationFrame(() => overlay.classList.add('is-active'));
    overlay._onClose = onClose;
  }
  function hideOverlay() {
    if (!overlay) return;
    overlay.classList.remove('is-active');
    setTimeout(() => (overlay.hidden = true), 300);
  }
  if (overlay) {
    overlay.addEventListener('click', () => {
      if (typeof overlay._onClose === 'function') overlay._onClose();
      hideOverlay();
    });
  }
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
  });

  function closeAll() {
    closeCart();
    closeMobileNav();
    closeFacets();
    hideOverlay();
  }

  /* ---------- Mobile nav (pokemillon style: drawer below header + slide-in panels) ---------- */
  const mobileNav = $('[data-mobile-nav]');
  const menuToggle = $('[data-menu-toggle]');
  function openMobileNav() {
    if (!mobileNav) return;
    const header = $('[data-header]');
    if (header) mobileNav.style.top = header.getBoundingClientRect().bottom + 'px';
    mobileNav.classList.add('is-open');
    document.documentElement.classList.add('nav-lock');
    if (menuToggle) { menuToggle.classList.add('is-open'); menuToggle.setAttribute('aria-expanded', 'true'); }
  }
  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    document.documentElement.classList.remove('nav-lock');
    if (menuToggle) { menuToggle.classList.remove('is-open'); menuToggle.setAttribute('aria-expanded', 'false'); }
    // Reset any open slide panels so the menu reopens at the root level
    $$('details.menu-opening', mobileNav).forEach((d) => { d.classList.remove('menu-opening'); d.removeAttribute('open'); });
  }
  if (menuToggle) {
    menuToggle.addEventListener('click', () => {
      if (mobileNav && mobileNav.classList.contains('is-open')) closeMobileNav();
      else openMobileNav();
    });
  }
  $$('[data-mobile-nav-close]').forEach((b) => b.addEventListener('click', closeMobileNav));

  if (mobileNav) {
    mobileNav.addEventListener('click', (e) => {
      // Back button: slide the panel out, then close the <details>
      const back = e.target.closest('[data-mobile-back]');
      if (back) {
        e.preventDefault();
        const det = back.closest('details');
        if (det) {
          det.classList.remove('menu-opening');
          setTimeout(() => det.removeAttribute('open'), 300);
        }
        return;
      }
      // Top-level rows: animate the sub panel sliding in
      const sum = e.target.closest('summary[data-slide]');
      if (sum) {
        const det = sum.closest('details');
        if (det.open) { e.preventDefault(); return; } // the panel covers it; only "back" closes
        requestAnimationFrame(() => {
          det.classList.add('menu-opening');
          const inner = $('[data-mobile-nav-inner]');
          if (inner) inner.scrollTop = 0;
        });
      }
    });
  }

  /* ---------- Facets drawer (mobile) ----------
     Looked up at call time + delegated events, because the collection area
     is re-rendered by the AJAX filters. */
  function openFacets() { const f = $('[data-facets]'); if (f) { f.classList.add('is-open'); showOverlay(closeFacets); } }
  function closeFacets() { const f = $('[data-facets]'); if (f) f.classList.remove('is-open'); }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-facets-toggle]')) openFacets();
    if (e.target.closest('[data-facets-close]')) { closeFacets(); hideOverlay(); }
  });

  /* ---------- Cart drawer ---------- */
  const cartDrawer = $('[data-cart-drawer]');
  function openCart() { if (cartDrawer) { cartDrawer.classList.add('is-open'); showOverlay(closeCart); } }
  function closeCart() { if (cartDrawer) cartDrawer.classList.remove('is-open'); }
  $$('[data-cart-open]').forEach((b) =>
    b.addEventListener('click', (e) => {
      if (UC.cartType === 'drawer' && cartDrawer) { e.preventDefault(); refreshCart().then(openCart); }
    })
  );
  $$('[data-cart-close]').forEach((b) => b.addEventListener('click', () => { closeCart(); hideOverlay(); }));

  // Shopify no usa un unico marcador: segun el formato de la tienda manda
  // {{amount}} (1,134.65), {{amount_with_comma_separator}} (1.134,65) y otros
  // cuatro. Antes solo se sustituia {{amount}}, asi que con el formato europeo
  // (€{{amount_with_comma_separator}}) el marcador salia crudo en el carrito.
  const MONEY_PLACEHOLDER = /\{\{\s*(\w+)\s*\}\}/;

  function groupMoney(cents, decimals, thousands, decimal) {
    const fixed = (cents / 100).toFixed(decimals);
    const negative = fixed.indexOf('-') === 0;
    const parts = (negative ? fixed.slice(1) : fixed).split('.');
    const whole = parts[0].replace(/(\d)(?=(\d{3})+$)/g, '$1' + thousands);
    return (negative ? '-' : '') + whole + (parts[1] ? decimal + parts[1] : '');
  }

  function formatMoney(cents, format) {
    const value = typeof cents === 'string' ? parseFloat(cents.replace(/[^0-9.-]/g, '')) : cents;
    if (typeof value !== 'number' || isNaN(value)) return '';

    const fmt = format || UC.moneyFormat || '{{amount_with_comma_separator}} €';
    // Algunas tiendas envuelven el formato en <span class=money>. En el
    // subtotal se pinta con textContent, asi que las etiquetas se verian.
    const clean = fmt.replace(/<[^>]*>/g, '');
    const match = clean.match(MONEY_PLACEHOLDER);
    let amount;

    switch (match && match[1]) {
      case 'amount_no_decimals':
        amount = groupMoney(value, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        amount = groupMoney(value, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        amount = groupMoney(value, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        amount = groupMoney(value, 2, "'", '.');
        break;
      case 'amount_with_space_separator':
        amount = groupMoney(value, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        amount = groupMoney(value, 0, ' ', ',');
        break;
      default:
        amount = groupMoney(value, 2, ',', '.');
    }

    // Sin marcador reconocible no devolvemos la plantilla cruda
    return match ? clean.replace(MONEY_PLACEHOLDER, amount) : amount;
  }

  async function refreshCart() {
    try {
      const res = await fetch(`${UC.routes.cart_url}.js`);
      const cart = await res.json();
      renderCart(cart);
      updateCartCount(cart.item_count);
    } catch (e) { console.error('Cart refresh failed', e); }
  }

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function renderCart(cart) {
    const itemsEl = $('[data-cart-items]');
    const subtotalEl = $('[data-cart-subtotal]');
    if (!itemsEl) return;
    if (!cart.items.length) {
      itemsEl.innerHTML = `<div class="cart-empty"><p>${(UC.strings && UC.strings.cartEmpty) || 'Tu carrito está vacío'}</p></div>`;
    } else {
      itemsEl.innerHTML = cart.items
        .map(
          (item, i) => `
        <div class="cart-item" data-line="${i + 1}">
          <a class="cart-item__img" href="${item.url}"><img src="${item.image ? item.image.replace(/(\.[^.]*)$/, '_120x$1') : ''}" alt="${item.product_title}" loading="lazy"></a>
          <div>
            <a class="cart-item__title" href="${item.url}">${item.product_title}</a>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<div style="font-size:.8rem;color:var(--color-text-muted)">${item.variant_title}</div>` : ''}
            <div class="quantity" style="margin-top:8px">
              <button type="button" data-qty-change data-line="${i + 1}" data-qty="${item.quantity - 1}" aria-label="-">−</button>
              <input type="text" value="${item.quantity}" readonly>
              <button type="button" data-qty-change data-line="${i + 1}" data-qty="${item.quantity + 1}" aria-label="+">+</button>
            </div>
          </div>
          <div style="text-align:right">
            <div class="cart-item__price">${formatMoney(item.final_line_price)}</div>
            <button type="button" class="cart-item__remove" data-qty-change data-line="${i + 1}" data-qty="0" style="background:none;border:0;color:var(--color-text-muted);font-size:.78rem;margin-top:8px;text-decoration:underline">Quitar</button>
          </div>
        </div>`
        )
        .join('');
    }
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    itemsEl.querySelectorAll('[data-qty-change]').forEach((btn) =>
      btn.addEventListener('click', () => changeLine(btn.dataset.line, parseInt(btn.dataset.qty, 10)))
    );
  }

  async function changeLine(line, quantity) {
    try {
      const res = await fetch(`${UC.routes.cart_change_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity })
      });
      const cart = await res.json();
      renderCart(cart);
      updateCartCount(cart.item_count);
    } catch (e) { console.error(e); }
  }

  /* ---------- Add to cart (forms + quick add) ---------- */
  $$('[data-product-form], form[action$="/cart/add"]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      if (UC.cartType !== 'drawer' && !form.hasAttribute('data-ajax')) return;
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const original = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = (UC.strings && UC.strings.loading) || '…'; }
      try {
        const formData = new FormData(form);
        const res = await fetch(`${UC.routes.cart_add_url}.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        });
        if (!res.ok) throw new Error('add failed');
        await refreshCart();
        openCart();
      } catch (err) {
        console.error(err);
        form.submit();
      } finally {
        if (btn) { btn.disabled = false; btn.innerHTML = original; }
      }
    });
  });

  /* ---------- Quick add buttons (product cards) ----------
     Delegated so buttons keep working after the grid is re-rendered by filters. */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    const id = btn.dataset.variantId;
    if (!id) return;
    btn.disabled = true;
    try {
      await fetch(`${UC.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
      });
      await refreshCart();
      openCart();
    } catch (err) { console.error(err); } finally { btn.disabled = false; }
  });

  /* ---------- Quantity steppers (product page) ---------- */
  $$('[data-quantity]').forEach((wrap) => {
    const input = wrap.querySelector('input');
    wrap.querySelectorAll('[data-qty-step]').forEach((b) =>
      b.addEventListener('click', () => {
        const step = parseInt(b.dataset.qtyStep, 10);
        const next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      })
    );
  });

  /* ---------- Product gallery ---------- */
  const gallery = $('[data-gallery]');
  if (gallery) {
    const mainImg = gallery.querySelector('[data-gallery-main] img');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach((thumb) =>
      thumb.addEventListener('click', () => {
        const full = thumb.dataset.full;
        if (mainImg && full) mainImg.src = full;
        gallery.querySelectorAll('[data-gallery-thumb]').forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      })
    );
  }

  /* ---------- Predictive search ---------- */
  const searchForms = $$('[data-predictive-search]');
  searchForms.forEach((wrap) => {
    const input = wrap.querySelector('input[type="search"], input[name="q"]');
    const results = wrap.querySelector('[data-predictive-results]');
    if (!input || !results) return;
    let timer;
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const term = input.value.trim();
      if (term.length < 2) { results.hidden = true; results.innerHTML = ''; return; }
      timer = setTimeout(() => runPredictive(term, results), 220);
    });
    input.addEventListener('focus', () => { if (results.innerHTML) results.hidden = false; });
    document.addEventListener('click', (e) => { if (!wrap.contains(e.target)) results.hidden = true; });
  });

  async function runPredictive(term, results) {
    results.hidden = false;
    results.innerHTML = `<div class="predictive__empty">${(UC.strings && UC.strings.loading) || '…'}</div>`;
    try {
      const url = `${UC.routes.predictive_search_url}?q=${encodeURIComponent(term)}&resources[type]=product,collection,page&resources[limit]=6&section_id=predictive-search`;
      const res = await fetch(url);
      const text = await res.text();
      const html = new DOMParser().parseFromString(text, 'text/html');
      const inner = html.querySelector('[data-predictive-inner]');
      results.innerHTML = inner ? inner.innerHTML : `<div class="predictive__empty">${(UC.strings && UC.strings.noResults) || 'Sin resultados'}</div>`;
    } catch (e) {
      console.error(e);
      results.hidden = true;
    }
  }

  /* ---------- Mega-menu sidebar tabs (pokemillon style) ---------- */
  $$('[data-mega-target]').forEach((tab) => {
    const activate = () => {
      const menu = tab.closest('.megamenu');
      if (!menu) return;
      $$('[data-mega-target]', menu).forEach((t) => t.classList.toggle('active', t === tab));
      $$('[data-mega-panel]', menu).forEach((p) => p.classList.toggle('active', p.dataset.megaPanel === tab.dataset.megaTarget));
    };
    tab.addEventListener('mouseenter', activate);
    tab.addEventListener('focus', activate);
  });

  /* ---------- Collection filters (AJAX via Section Rendering API) ---------- */
  function collectionRoot() { return $('[data-collection-root]'); }

  async function applyFacets(url, scroll, skipHistory) {
    const root = collectionRoot();
    if (!root) return;
    const sectionId = root.dataset.sectionId;
    let qs;
    if (typeof url === 'string') {
      qs = url.indexOf('?') > -1 ? url.split('?')[1] : '';
    } else {
      const form = $('[data-facets-form]');
      if (!form) return;
      const params = new URLSearchParams(new FormData(form));
      const sortSelect = $('[data-sort-select]');
      if (sortSelect) params.set('sort_by', sortSelect.value);
      // Drop empty params so the URL stays clean
      Array.from(params.keys()).forEach((k) => { if (params.get(k) === '') params.delete(k); });
      qs = params.toString();
    }
    const facetsEl = $('[data-facets]');
    const facetsOpen = facetsEl && facetsEl.classList.contains('is-open');
    root.classList.add('is-loading');
    try {
      const sep = qs ? '&' : '';
      const res = await fetch(`${window.location.pathname}?${qs}${sep}section_id=${sectionId}`);
      const text = await res.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const fresh = doc.querySelector('[data-collection-root]');
      if (fresh) {
        root.innerHTML = fresh.innerHTML;
        paintPriceSliders();
        if (!skipHistory) history.pushState({ ultraFacets: true }, '', `${window.location.pathname}${qs ? '?' + qs : ''}`);
        if (facetsOpen) { const f = $('[data-facets]'); if (f) f.classList.add('is-open'); }
        if (scroll) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } catch (err) { console.error('Filter update failed', err); }
    root.classList.remove('is-loading');
  }

  let facetsTimer;
  document.addEventListener('change', (e) => {
    if (!collectionRoot()) return;
    if (e.target.closest('[data-facets-form]') || e.target.matches('[data-sort-select]')) {
      clearTimeout(facetsTimer);
      facetsTimer = setTimeout(() => applyFacets(), 150);
    }
  });
  document.addEventListener('submit', (e) => {
    if (e.target.matches('[data-facets-form]')) { e.preventDefault(); applyFacets(); }
  });
  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-facet-link]');
    if (!link || !collectionRoot()) return;
    e.preventDefault();
    applyFacets(link.getAttribute('href'), link.hasAttribute('data-scroll'));
  });
  window.addEventListener('popstate', () => {
    if (collectionRoot()) applyFacets(window.location.search, false, true);
  });

  /* ---------- Price range slider ----------
     The range inputs carry no "name": they only drive the number fields, which
     hold Shopify's real filter params. Releasing a handle fires `change`, which
     the facets listener above already picks up. */
  function priceParts(slider) {
    const scope = slider.closest('.facets__content') || document;
    return {
      max: parseFloat(slider.dataset.max) || 0,
      lo: slider.querySelector('[data-price-handle="min"]'),
      hi: slider.querySelector('[data-price-handle="max"]'),
      fill: slider.querySelector('[data-price-fill]'),
      numMin: scope.querySelector('[data-price-number="min"]'),
      numMax: scope.querySelector('[data-price-number="max"]'),
    };
  }

  function syncPriceSlider(slider, movedHandle) {
    const p = priceParts(slider);
    if (!p.max || !p.lo || !p.hi) return;
    let a = parseFloat(p.lo.value) || 0;
    let b = parseFloat(p.hi.value);
    if (isNaN(b)) b = p.max;
    // handles must never cross over
    if (movedHandle === 'min' && a > b) { a = b; p.lo.value = a; }
    if (movedHandle === 'max' && b < a) { b = a; p.hi.value = b; }
    if (p.fill) {
      p.fill.style.left = (a / p.max * 100) + '%';
      p.fill.style.right = (100 - (b / p.max * 100)) + '%';
    }
    if (movedHandle) {
      // an untouched end stays empty, so the URL keeps only real filters
      if (p.numMin) p.numMin.value = a > 0 ? a : '';
      if (p.numMax) p.numMax.value = b < p.max ? b : '';
    }
  }

  function sliderFromNumbers(slider) {
    const p = priceParts(slider);
    if (!p.max || !p.lo || !p.hi) return;
    p.lo.value = p.numMin && p.numMin.value !== '' ? p.numMin.value : 0;
    p.hi.value = p.numMax && p.numMax.value !== '' ? p.numMax.value : p.max;
    syncPriceSlider(slider);
  }

  function paintPriceSliders() {
    $$('[data-price-slider]').forEach((s) => syncPriceSlider(s));
  }

  document.addEventListener('input', (e) => {
    const handle = e.target.closest('[data-price-handle]');
    if (handle) {
      syncPriceSlider(handle.closest('[data-price-slider]'), handle.dataset.priceHandle);
      return;
    }
    const num = e.target.closest('[data-price-number]');
    if (num) {
      const group = num.closest('.facets__content');
      const slider = group && group.querySelector('[data-price-slider]');
      if (slider) sliderFromNumbers(slider);
    }
  });

  /* Grab anywhere on the bar, not just on the 17px thumb. */
  function valueAtX(slider, clientX) {
    const rail = slider.querySelector('.price-slider__rail') || slider;
    const r = rail.getBoundingClientRect();
    const max = parseFloat(slider.dataset.max) || 0;
    const ratio = Math.min(1, Math.max(0, (clientX - r.left) / r.width));
    return Math.round(ratio * max);
  }

  let priceDrag = null;

  document.addEventListener('pointerdown', (e) => {
    const slider = e.target.closest('[data-price-slider]');
    if (!slider) return;
    const p = priceParts(slider);
    if (!p.max || !p.lo || !p.hi) return;

    const v = valueAtX(slider, e.clientX);
    const dLo = Math.abs(v - (parseFloat(p.lo.value) || 0));
    const dHi = Math.abs(v - (parseFloat(p.hi.value) || p.max));
    let which;
    if (dLo < dHi) which = 'min';
    else if (dHi < dLo) which = 'max';
    else which = v >= (parseFloat(p.hi.value) || p.max) ? 'max' : 'min';

    const input = which === 'min' ? p.lo : p.hi;
    input.value = v;
    syncPriceSlider(slider, which);
    priceDrag = { slider, which, input };
    slider.classList.add('is-dragging');
    if (slider.setPointerCapture) { try { slider.setPointerCapture(e.pointerId); } catch (err) {} }
    e.preventDefault();
  });

  document.addEventListener('pointermove', (e) => {
    if (!priceDrag) return;
    priceDrag.input.value = valueAtX(priceDrag.slider, e.clientX);
    syncPriceSlider(priceDrag.slider, priceDrag.which);
  });

  document.addEventListener('pointerup', () => {
    if (!priceDrag) return;
    const { slider, input } = priceDrag;
    priceDrag = null;
    slider.classList.remove('is-dragging');
    // let the facets listener pick it up and refresh the grid
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  paintPriceSliders();

  /* ---------- Add-to-cart helper (shared) ---------- */
  async function addToCart(items) {
    try {
      await fetch(`${UC.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      });
      await refreshCart();
      openCart();
      return true;
    } catch (e) { console.error(e); return false; }
  }
  const UC_CHECK_SVG = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';

  /* ---------- "Mejores cartas" carousel + 3D coverflow lightbox ---------- */
  $$('[data-uc-cards]').forEach((root) => {
    const track = $('[data-uc-track]', root);
    if (!track) return;
    const prev = $('[data-uc-prev]', root);
    const next = $('[data-uc-next]', root);
    const cards = $$('.uc-cards__card', root);
    const itemW = () => {
      const it = track.querySelector('.uc-cards__item');
      if (!it) return 120;
      return it.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || '10');
    };
    const scrollByN = (dir) => track.scrollBy({ left: itemW() * dir * 3, behavior: 'smooth' });
    if (prev) prev.addEventListener('click', () => scrollByN(-1));
    if (next) next.addEventListener('click', () => scrollByN(1));

    // 3D tilt on hover
    cards.forEach((card) => {
      card.addEventListener('mousemove', (e) => {
        const r = card.getBoundingClientRect();
        const px = ((e.clientX - r.left) / r.width - 0.5) * 2;
        const py = ((e.clientY - r.top) / r.height - 0.5) * 2;
        card.style.transform = `rotateX(${py * -10}deg) rotateY(${px * 10}deg) scale(1.06)`;
      }, { passive: true });
      card.addEventListener('mouseleave', () => { card.style.transform = ''; });
    });

    // Drag to scroll
    let down = false, startX = 0, sl = 0, moved = false;
    track.addEventListener('mousedown', (e) => { down = true; moved = false; startX = e.pageX; sl = track.scrollLeft; track.classList.add('is-dragging'); });
    const endDrag = () => { down = false; track.classList.remove('is-dragging'); };
    track.addEventListener('mouseleave', endDrag);
    window.addEventListener('mouseup', endDrag);
    track.addEventListener('mousemove', (e) => {
      if (!down) return;
      const dx = e.pageX - startX;
      if (Math.abs(dx) > 4) moved = true;
      track.scrollLeft = sl - dx * 1.2;
    });

    // Auto-scroll (pauses on interaction)
    let auto;
    const stopAuto = () => clearInterval(auto);
    const startAuto = () => {
      stopAuto();
      auto = setInterval(() => {
        if (track.scrollLeft + track.clientWidth >= track.scrollWidth - itemW() * 0.5) track.scrollTo({ left: 0, behavior: 'smooth' });
        else scrollByN(1);
      }, 3000);
    };
    root.addEventListener('mouseenter', stopAuto);
    root.addEventListener('mouseleave', startAuto);
    track.addEventListener('touchstart', stopAuto, { passive: true });
    startAuto();

    // ---- 3D lightbox ----
    const box = $('[data-uc-lightbox]', root);
    if (box) {
      const stage = $('[data-uc-stage]', box);
      const items = $$('[data-uc-3ditem]', box);
      const counter = $('[data-uc-counter]', box);
      const total = items.length;
      let idx = 0;

      const layout = (active) => {
        const stageW = stage.offsetWidth || window.innerWidth;
        const visible = Math.min(2, Math.floor((total - 1) / 2));
        const spacing = Math.min(230, (stageW / (visible * 2 + 1)) * 0.9);
        items.forEach((item, i) => {
          let diff = i - active;
          if (diff > total / 2) diff -= total;
          if (diff < -total / 2) diff += total;
          const absD = Math.abs(diff);
          const scale = diff === 0 ? 1 : Math.max(0.6, 1 - absD * 0.18);
          const opacity = diff === 0 ? 1 : Math.max(0.25, 1 - absD * 0.32);
          const blur = diff === 0 ? 0 : absD * 1.5;
          item.style.transform = `translate(-50%, -50%) translateX(${diff * spacing}px) translateZ(${-absD * 130}px) rotateY(${diff * -18}deg) scale(${scale})`;
          item.style.opacity = opacity;
          item.style.filter = blur ? `blur(${blur}px)` : '';
          item.style.zIndex = String(100 - absD * 10);
          item.classList.toggle('is-center', diff === 0);
          item.style.display = absD <= visible + 1 ? '' : 'none';
        });
        if (counter) counter.textContent = `${active + 1} / ${total}`;
      };
      const openBox = (i) => {
        idx = i; box.hidden = false; box.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('nav-lock');
        requestAnimationFrame(() => { box.classList.add('is-open'); layout(idx); });
      };
      const closeBox = () => {
        box.classList.remove('is-open'); box.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('nav-lock');
        setTimeout(() => { box.hidden = true; }, 250);
      };
      const go = (d) => { idx = (idx + d + total) % total; layout(idx); };

      cards.forEach((card) => card.addEventListener('click', () => {
        if (moved) { moved = false; return; }
        openBox(parseInt(card.dataset.ucIndex, 10) || 0);
      }));
      const cl = $('[data-uc-close]', box); if (cl) cl.addEventListener('click', closeBox);
      const bp = $('[data-uc-3dprev]', box); if (bp) bp.addEventListener('click', () => go(-1));
      const bn = $('[data-uc-3dnext]', box); if (bn) bn.addEventListener('click', () => go(1));
      box.addEventListener('click', (e) => { if (e.target === box || e.target === stage) closeBox(); });
      items.forEach((item, i) => item.addEventListener('click', () => { if (i !== idx) { idx = i; layout(idx); } }));
      document.addEventListener('keydown', (e) => {
        if (box.hidden) return;
        if (e.key === 'Escape') closeBox();
        else if (e.key === 'ArrowLeft') go(-1);
        else if (e.key === 'ArrowRight') go(1);
      });
      window.addEventListener('resize', () => { if (!box.hidden) layout(idx); });
    }
  });

  /* ---------- "Completa tu pedido" (complementary products) ---------- */
  const recRoot = $('[data-uc-rec-root]');
  if (recRoot && recRoot.dataset.url) {
    fetch(recRoot.dataset.url)
      .then((r) => r.text())
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const sec = doc.querySelector('[data-uc-rec]');
        if (sec) recRoot.innerHTML = sec.outerHTML;
      })
      .catch((e) => console.error('Complementary load failed', e));
  }
  // Delegated interactions (root is filled asynchronously)
  document.addEventListener('click', (e) => {
    const check = e.target.closest('[data-uc-rec-check]');
    if (check) {
      const card = check.closest('[data-uc-rec-card]');
      if (card && card.dataset.available === 'true') card.classList.toggle('is-selected');
      return;
    }
    const atc = e.target.closest('[data-uc-rec-atc]');
    if (atc) {
      e.preventDefault();
      const id = atc.dataset.variantId;
      if (!id || atc.disabled) return;
      atc.disabled = true;
      addToCart([{ id: parseInt(id, 10), quantity: 1 }]).then((ok) => {
        atc.disabled = false;
        if (ok) { atc.classList.add('uc-rec__atc--done'); atc.innerHTML = UC_CHECK_SVG; }
      });
      return;
    }
    const addall = e.target.closest('[data-uc-addall]');
    if (addall) {
      e.preventDefault();
      const items = $$('[data-uc-rec-card].is-selected')
        .map((c) => ({ id: parseInt(c.dataset.variantId, 10), quantity: 1 }))
        .filter((x) => x.id);
      if (items.length) addToCart(items);
      return;
    }
  });

  /* ---------- Share buttons (Copiar enlace + WhatsApp) ---------- */
  $$('[data-share]').forEach((share) => {
    const url = window.location.href;
    const title = share.dataset.title || document.title;
    const wa = share.querySelector('[data-share-wa]');
    if (wa) wa.href = `https://wa.me/?text=${encodeURIComponent(title + ' ' + url)}`;
    const copyBtn = share.querySelector('[data-share-copy]');
    if (copyBtn) {
      copyBtn.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(url);
        } catch (e) {
          const t = document.createElement('textarea');
          t.value = url; document.body.appendChild(t); t.select();
          try { document.execCommand('copy'); } catch (_) {}
          t.remove();
        }
        const txt = copyBtn.querySelector('[data-share-copy-text]');
        copyBtn.classList.add('is-copied');
        const prev = txt ? txt.textContent : '';
        if (txt) txt.textContent = '¡Copiado!';
        setTimeout(() => { copyBtn.classList.remove('is-copied'); if (txt) txt.textContent = prev; }, 1800);
      });
    }
  });

  /* ---------- Announcement marquee (constant speed regardless of length) ---------- */
  const marqueeTrack = $('[data-announcement-track]');
  if (marqueeTrack) {
    const group = marqueeTrack.querySelector('.announcement__group');
    const setDuration = () => {
      if (!group) return;
      const w = group.getBoundingClientRect().width;
      const speed = 60; // px per second
      if (w > 0) marqueeTrack.style.animationDuration = Math.max(14, w / speed) + 's';
    };
    setDuration();
    window.addEventListener('resize', setDuration);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(setDuration);
  }

  /* ---------- Variant picker (price / stock / SKU / image update on click) ---------- */
  function applyVariant(form) {
    const dataEl = form.querySelector('[data-variant-data]');
    if (!dataEl) return;

    let variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    const picked = form.querySelector('select[name="id"]') ||
                   form.querySelector('input[name="id"]:checked') ||
                   form.querySelector('input[name="id"]');
    if (!picked) return;

    const variant = variants.find((v) => String(v.id) === String(picked.value));
    if (!variant) return;

    const info = form.closest('.product-info') || document;

    const priceEl = info.querySelector('[data-variant-price]');
    if (priceEl) priceEl.innerHTML = variant.price_html;

    const stockEl = info.querySelector('[data-variant-stock]');
    if (stockEl) stockEl.innerHTML = variant.stock_html;

    const skuEl = info.querySelector('[data-variant-sku]');
    if (skuEl) skuEl.innerHTML = variant.sku_html;

    const notify = info.querySelector('[data-notify]');
    if (notify) notify.hidden = !!variant.available;

    const atc = form.querySelector('[data-atc-submit]');
    if (atc) {
      atc.disabled = !variant.available;
      atc.textContent = variant.available
        ? (atc.dataset.textAdd || atc.textContent)
        : (atc.dataset.textSoldOut || atc.textContent);
    }

    // Swap the main photo when the variant has its own image
    if (variant.image) {
      const mainImg = document.querySelector('[data-gallery-main] img');
      if (mainImg) mainImg.src = variant.image;
      if (variant.media_id != null) {
        document.querySelectorAll('[data-gallery-thumb]').forEach((t) => {
          t.classList.toggle('is-active', String(t.dataset.mediaId) === String(variant.media_id));
        });
      }
    }

    // Keep the URL shareable without reloading
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    } catch (e) { /* older browsers: not critical */ }
  }

  /* ---------- Selector por opcion (Formato / Idioma en grupos separados) ---------- */
  // El formulario envia valores de opcion, no ids. Aqui se cruzan con el JSON de
  // variantes para rellenar el input oculto name="id" y marcar lo que esta agotado.
  function findVariantByOptions(variants, values) {
    return variants.find((v) => Array.isArray(v.options) &&
      v.options.length === values.length &&
      v.options.every((opt, i) => opt === values[i]));
  }

  function syncVariantOptions(form) {
    const dataEl = form.querySelector('[data-variant-data]');
    const hidden = form.querySelector('[data-variant-id]');
    const groups = $$('[data-option-group]', form);
    if (!dataEl || !hidden || !groups.length) return;

    let variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    const values = groups.map((g) => {
      const checked = g.querySelector('input[type="radio"]:checked');
      return checked ? checked.value : null;
    });
    if (values.some((v) => v === null)) return;

    // Marca en gris las combinaciones agotadas, dejando fijo el resto de opciones
    groups.forEach((group, gi) => {
      group.querySelectorAll('input[type="radio"]').forEach((input) => {
        const probe = values.slice();
        probe[gi] = input.value;
        const match = findVariantByOptions(variants, probe);
        const pill = input.closest('.variant-pill');
        if (pill) pill.classList.toggle('is-soldout', !match || !match.available);
      });
    });

    const variant = findVariantByOptions(variants, values);
    if (!variant) return;
    hidden.value = variant.id;
    applyVariant(form);
  }

  document.addEventListener('change', (e) => {
    const optionInput = e.target.closest('[data-option-group] input[type="radio"]');
    if (optionInput) {
      const form = optionInput.closest('[data-product-form]');
      if (form) syncVariantOptions(form);
      return;
    }
    const field = e.target.closest('[data-product-form] input[name="id"], [data-product-form] select[name="id"]');
    if (!field) return;
    applyVariant(field.closest('[data-product-form]'));
  });

  $$('[data-product-form]').forEach(syncVariantOptions);

  /* ---------- Banner principal rotativo ---------- */
  // El desplazamiento real lo hace el navegador (scroll-snap). Aqui solo se
  // mueve el carril, se marcan los puntos y se lleva el temporizador.
  const heroReduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initHero(root) {
    const viewport = root.querySelector('[data-hero-viewport]');
    const slides = $$('[data-hero-slide]', root);
    if (!viewport || slides.length < 2) return;

    const dots = $$('[data-hero-dot]', root);
    const interval = Math.max(3000, parseInt(root.dataset.heroInterval, 10) || 6000);
    const wantsAutoplay = root.dataset.heroAutoplay === 'true';
    let index = 0;
    let timer = null;

    const goTo = (i, smooth) => {
      index = (i + slides.length) % slides.length;
      viewport.scrollTo({
        left: viewport.clientWidth * index,
        behavior: smooth === false || heroReduceMotion.matches ? 'auto' : 'smooth'
      });
    };

    const paint = () => {
      dots.forEach((dot, di) => {
        const on = di === index;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-selected', String(on));
      });
    };

    // El scroll manda: si el usuario arrastra, el indice se recalcula desde ahi
    let raf = null;
    viewport.addEventListener('scroll', () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = null;
        const w = viewport.clientWidth;
        if (!w) return;
        const i = Math.round(viewport.scrollLeft / w);
        if (i !== index && i >= 0 && i < slides.length) { index = i; paint(); }
      });
    }, { passive: true });

    const stop = () => { if (timer) { clearInterval(timer); timer = null; } };
    const start = () => {
      stop();
      if (!wantsAutoplay || heroReduceMotion.matches || document.hidden) return;
      timer = setInterval(() => goTo(index + 1), interval);
    };

    root.querySelectorAll('[data-hero-prev]').forEach((b) =>
      b.addEventListener('click', () => { goTo(index - 1); start(); }));
    root.querySelectorAll('[data-hero-next]').forEach((b) =>
      b.addEventListener('click', () => { goTo(index + 1); start(); }));
    dots.forEach((dot) =>
      dot.addEventListener('click', () => { goTo(parseInt(dot.dataset.heroIndex, 10) || 0); start(); }));

    viewport.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index + 1); start(); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(index - 1); start(); }
    });

    // No pelear con el usuario mientras mira, toca o tabula
    ['pointerenter', 'focusin', 'touchstart'].forEach((ev) =>
      root.addEventListener(ev, stop, { passive: true }));
    ['pointerleave', 'focusout', 'touchend'].forEach((ev) =>
      root.addEventListener(ev, start, { passive: true }));
    document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));
    heroReduceMotion.addEventListener('change', start);

    // Al cambiar el ancho, scrollLeft deja de cuadrar con la diapositiva
    window.addEventListener('resize', () => goTo(index, false));

    paint();
    start();
  }

  $$('[data-hero]').forEach(initHero);

  // Editor de temas: al anadir o quitar imagenes Shopify repinta la seccion,
  // y al pinchar una imagen en la lista la traemos a la vista.
  document.addEventListener('shopify:section:load', (e) => {
    $$('[data-hero]', e.target).forEach(initHero);
  });
  document.addEventListener('shopify:block:select', (e) => {
    const slide = e.target && e.target.closest ? e.target.closest('[data-hero-slide]') : null;
    if (!slide) return;
    const root = slide.closest('[data-hero]');
    const viewport = root && root.querySelector('[data-hero-viewport]');
    if (!viewport) return;
    const i = $$('[data-hero-slide]', root).indexOf(slide);
    if (i >= 0) viewport.scrollTo({ left: viewport.clientWidth * i, behavior: 'smooth' });
  });

  /* ---------- Opiniones en carrusel ---------- */
  // Avanza de una tarjeta en una, no de pantalla en pantalla: con 3 visibles
  // saltar de tres en tres se lee como un parpadeo.
  function initReviews(root) {
    const viewport = root.querySelector('[data-reviews-viewport]');
    const items = $$('[data-reviews-item]', root);
    const controls = root.querySelector('[data-reviews-controls]');
    if (!viewport || items.length < 2) return;

    const interval = Math.max(3000, parseInt(root.dataset.reviewsInterval, 10) || 5000);
    const wantsAutoplay = root.dataset.reviewsAutoplay === 'true';
    let timer = null;

    // Con pocas opiniones caben todas: ni controles ni movimiento
    const overflows = () => viewport.scrollWidth - viewport.clientWidth > 4;

    const step = () => {
      if (items.length < 2) return viewport.clientWidth;
      const a = items[0].getBoundingClientRect();
      const b = items[1].getBoundingClientRect();
      return Math.round(b.left - a.left) || Math.round(a.width);
    };

    const goBy = (dir) => {
      const max = viewport.scrollWidth - viewport.clientWidth;
      let next = viewport.scrollLeft + dir * step();
      // al llegar al final vuelve al principio, y al reves
      if (next > max - 2) next = dir > 0 ? 0 : max;
      if (next < 0) next = max;
      viewport.scrollTo({
        left: next,
        behavior: heroReduceMotion.matches ? 'auto' : 'smooth'
      });
    };

    const stop = () => { if (timer) { clearInterval(timer); timer = null; } };
    const start = () => {
      stop();
      if (!wantsAutoplay || heroReduceMotion.matches || document.hidden || !overflows()) return;
      timer = setInterval(() => goBy(1), interval);
    };

    const sync = () => {
      const on = overflows();
      if (controls) controls.hidden = !on;
      viewport.style.scrollSnapType = on ? '' : 'none';
      if (on) { start(); } else { stop(); viewport.scrollLeft = 0; }
    };

    root.querySelectorAll('[data-reviews-prev]').forEach((b) =>
      b.addEventListener('click', () => { goBy(-1); start(); }));
    root.querySelectorAll('[data-reviews-next]').forEach((b) =>
      b.addEventListener('click', () => { goBy(1); start(); }));

    viewport.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); goBy(1); start(); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goBy(-1); start(); }
    });

    ['pointerenter', 'focusin', 'touchstart'].forEach((ev) =>
      root.addEventListener(ev, stop, { passive: true }));
    ['pointerleave', 'focusout', 'touchend'].forEach((ev) =>
      root.addEventListener(ev, start, { passive: true }));
    document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));
    heroReduceMotion.addEventListener('change', sync);
    window.addEventListener('resize', sync);

    sync();
  }

  $$('[data-reviews]').forEach(initReviews);

  document.addEventListener('shopify:section:load', (e) => {
    $$('[data-reviews]', e.target).forEach(initReviews);
  });

  /* ---------- Formulario de resena de producto ---------- */
  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-review-toggle]');
    if (!toggle) return;
    const panel = toggle.closest('[data-review]').querySelector('[data-review-panel]');
    if (!panel) return;
    const open = !panel.classList.contains('is-open');
    panel.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', String(open));
    if (open) {
      const first = panel.querySelector('input[name="contact[name]"]');
      if (first) first.focus();
    }
  });

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-review-form]');
    if (!form) return;
    const hp = form.querySelector('[data-review-hp]');
    if (hp && hp.value.trim() !== '') { e.preventDefault(); return; }
    const btn = form.querySelector('[data-review-submit]');
    if (btn) { btn.disabled = true; if (btn.dataset.textSending) btn.textContent = btn.dataset.textSending; }
  });

  /* ---------- Boton flotante de WhatsApp ---------- */
  // La web no puede enviar el mensaje: abre WhatsApp con el texto ya escrito
  // y lo manda el propio visitante. Es lo unico posible sin API de pago.
  (function initWaFloat() {
    const root = $('[data-wa-float]');
    if (!root) return;

    const panel = root.querySelector('[data-wa-panel]');
    const toggle = root.querySelector('[data-wa-toggle]');
    const text = root.querySelector('[data-wa-text]');
    const send = root.querySelector('[data-wa-send]');
    const form = root.querySelector('[data-wa-form]');
    const number = root.dataset.waNumber || '';
    if (!panel || !toggle || !number) return;

    const setOpen = (open) => {
      panel.hidden = !open;
      root.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      if (open && text) text.focus();
    };

    const syncSend = () => {
      if (send) send.disabled = !text || text.value.trim() === '';
    };

    const submit = () => {
      const msg = text ? text.value.trim() : '';
      if (!msg) return;
      // La pagina desde la que escribe ayuda a saber de que producto habla
      const body = msg + '\n\n— Enviado desde ' + window.location.href;
      window.open('https://wa.me/' + number + '?text=' + encodeURIComponent(body), '_blank', 'noopener');
      if (text) { text.value = ''; syncSend(); }
      setOpen(false);
    };

    toggle.addEventListener('click', () => setOpen(panel.hidden));
    root.querySelectorAll('[data-wa-close]').forEach((b) =>
      b.addEventListener('click', () => { setOpen(false); toggle.focus(); }));

    if (form) form.addEventListener('submit', (e) => { e.preventDefault(); submit(); });
    if (text) {
      text.addEventListener('input', () => {
        syncSend();
        // el area crece con el texto, hasta el tope del CSS
        text.style.height = 'auto';
        text.style.height = text.scrollHeight + 'px';
      });
      // Enter envia, Mayus+Enter hace salto de linea
      text.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); submit(); }
      });
    }
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !panel.hidden) { setOpen(false); toggle.focus(); }
    });

    syncSend();
  })();

  /* ---------- Aviso de reposicion ---------- */
  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-notify-toggle]');
    if (!toggle) return;
    const panel = toggle.closest('[data-notify]').querySelector('[data-notify-panel]');
    if (!panel) return;
    const open = !panel.classList.contains('is-open');
    panel.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', String(open));
    if (open) {
      const input = panel.querySelector('input[type="email"]');
      if (input) input.focus();
    }
  });

  /* ---------- Vende tus cartas ---------- */
  // Cada registro lleva una referencia (UC-XXXXXX) que va en el email del
  // formulario y en el mensaje de las fotos, para emparejarlos sin adivinar.
  // Tras enviar, Shopify recarga la página y el servidor ya no sabe qué se
  // escribió: por eso la referencia, el nombre y la carta se guardan en
  // sessionStorage y se leen al pintar el mensaje de éxito.
  const SELL_KEY = 'uc-sell-registro';

  function sellRef() {
    const abc = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'; // sin 0/O ni 1/I: se dicta sin dudas
    let out = '';
    for (let i = 0; i < 6; i++) out += abc[Math.floor(Math.random() * abc.length)];
    return 'UC-' + out;
  }

  function fillSellSuccess() {
    const box = $('[data-sell-success]');
    if (!box) return;

    let data = null;
    try { data = JSON.parse(sessionStorage.getItem(SELL_KEY) || 'null'); } catch (_) { data = null; }
    const ref = data && data.ref ? data.ref : '';

    const wrap = box.querySelector('[data-sell-ref-wrap]');
    const code = box.querySelector('[data-sell-ref]');
    const note = box.querySelector('[data-sell-ref-note]');
    if (ref && wrap && code) {
      code.textContent = ref;
      wrap.hidden = false;
      if (note && note.dataset.textRef) note.textContent = note.dataset.textRef;
    }

    const lines = [];
    if (ref) lines.push('Referencia: ' + ref);
    if (data && data.name) lines.push('Nombre: ' + data.name);
    if (data && data.card) lines.push('Carta: ' + data.card);
    const extra = lines.length ? '\n\n' + lines.join('\n') : '';

    const wa = box.querySelector('[data-sell-wa]');
    if (wa) wa.href = (wa.dataset.waBase || '') + encodeURIComponent((wa.dataset.waTemplate || '') + extra);

    const mail = box.querySelector('[data-sell-mail]');
    if (mail && ref) {
      const [to] = mail.getAttribute('href').split('?');
      mail.href = to + '?subject=' + encodeURIComponent('Fotos de mi carta · ' + ref) +
        '&body=' + encodeURIComponent('Hola, os envío las fotos de mi carta.' + extra);
    }
  }
  fillSellSuccess();

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-sell-form]');
    if (!form) return;

    // Trampa antispam: sólo un bot rellena un campo que no se ve.
    const hp = form.querySelector('[data-sell-hp]');
    if (hp && hp.value.trim() !== '') {
      e.preventDefault();
      return;
    }

    const ref = sellRef();
    const refInput = form.querySelector('[data-sell-ref-input]');
    if (refInput) refInput.value = ref;
    const val = (sel) => {
      const el = form.querySelector(sel);
      return el ? el.value.trim() : '';
    };
    try {
      sessionStorage.setItem(SELL_KEY, JSON.stringify({
        ref,
        name: val('[name="contact[name]"]'),
        card: val('[data-sell-card]')
      }));
    } catch (_) { /* sin almacenamiento: el éxito pide nombre y email en su lugar */ }

    const btn = form.querySelector('[data-sell-submit]');
    if (btn) {
      btn.disabled = true;
      if (btn.dataset.textSending) btn.textContent = btn.dataset.textSending;
    }
  });

  /* ---------- Init ---------- */
  refreshCart();
})();
